module.exports = __webpack_public_path__ + "img/logo-app.e0b06bd9.jpg";